import React, { Component } from "react";
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  TextField
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import { actualizarMensaje } from "../../redux/actions/actGlobal";
import { connect } from "react-redux";
import {
  consulta, obtenerValoresFiltros, formulario, mostrarError, obtenerValores
} from "../../global/js/funciones";
import emma_w from '../../global/imagenes/emma_w.png';
import TareasTerminadas from '../general/TareasTerminadas';
import BuscarPersona from '../general/BuscarPersona';
import AppBarModal from '../general/AppBarModal';
import { BtnForm } from "../general/BotonesAccion";
import { CARRERAS, ESTADO, TIPO_ACOMPANAMIENTO_DOCENTE } from './helper';


const styles = (theme) => ({
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 16px'
  },
  card: {
    marginBottom: '20px',
    padding: '20px'
  },
  formControl: {
    minWidth: '100%',
    marginBottom: '20px'
  },
  intro: {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '30px',
    borderLeft: '5px solid #B70E0C'
  },
  sectionTitle: {
    color: '#B70E0C',
    marginBottom: '15px',
    fontWeight: 'bold'
  },
  pointer: {
    cursor: 'pointer'
  }
});

class NuevoAdministrar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      programaSeleccionado: '',
      asignaturaSeleccionada: '',
      asignaturaSeleccionadaObj: null,
      estudianteSeleccionado: '',
      profesor: { id: '', identificacion: '', nombre_completo: '' },
      buscarProfesor: false,
      modalObservacion: false,
      observacionReporte: '',
      estudiantesReportados: [],
      modalDetalle: false,
      estudianteDetalle: null,
      dialogoConfirmacion: false,
      cargando: true,
      listarPrograma: [],
      materiasProfesor: [],
      estudiantesMateria: [],
      tipoAcompanamientoId: null,

    };
  }

  componentDidMount() {
    this.cargarTiposAcompanamiento();
  }

  cargarTiposAcompanamiento = async () => {
    try {
      const tipos_acompanamientos = await obtenerValores(TIPO_ACOMPANAMIENTO_DOCENTE);
      this.setState({
        tipoAcompanamientoId: tipos_acompanamientos[0]?.id || null,
        cargando: false
      });
    } catch (error) {
      this.setState({ cargando: false });
      this.props.actualizarMensaje({ titulo: 'Error cargando tipos de acompañamiento', tipo: 'error', mostrar: true, tiempo: 4000 });
    }
  }

  ObtenerProgramasProfesorGestionar = (identificacion) => {
    return new Promise((resolve) => {
      consulta(`api/v1.0/acompanamiento_docente/ObtenerProgramasProfesorGestionar/${identificacion}`, null, null, (error, estado, resp) => {
        resolve(resp);
      });
    });
  }

  cargarProgramasProfesor = async (identificacion) => {
    try {
      this.setState({ cargando: true });
      const programasResp = await this.ObtenerProgramasProfesorGestionar(identificacion);
      
      if (!(programasResp.error)) {
        let listarPrograma = await obtenerValoresFiltros([
          { 'llave': 'generica', 'valor': CARRERAS },
          { 'llave': 'estado', 'valor': ESTADO },
          { 'llave': 'codigos_in', 'valor': programasResp.programas }
        ]);

        listarPrograma = listarPrograma.map((Val) => ({
          value: Val.id,
          label: Val.nombre,
          codigo: Val.codigo,
        }));

        this.setState({
          listarPrograma,
          cargando: false
        });
      } else {
        this.setState({ 
          listarPrograma: [],
          cargando: false 
        });
        this.props.actualizarMensaje({ titulo: 'No se encontraron programas para este profesor', tipo: 'warning', mostrar: true, tiempo: 4000 });
      }

    } catch (error) {
      this.setState({ 
        listarPrograma: [],
        cargando: false 
      });
      this.props.actualizarMensaje({ titulo: 'Error cargando programas del profesor', tipo: 'error', mostrar: true, tiempo: 4000 });
    }
  }

  ObtenerDatosProfesor = (programa, identificacion) => {
    return new Promise((resolve) => {
      consulta(`api/v1.0/acompanamiento_docente/ObtenerDatosProfesor_administrar/${programa}/${identificacion}`, null, null, (error, estado, resp) => {
        resolve(resp);
      });
    });
  }

  ObtenerEstudiantesProfesor = (grupo) => {
    return new Promise((resolve) => {
      const grupoId = parseInt(grupo, 10);
      consulta(`api/v1.0/acompanamiento_docente/ObtenerEstudiantesProfesor/${grupoId}`, null, null, (error, estado, resp) => {
        resolve(resp);
      });
    });
  }

  handleProgramaChange = async (event) => {
    const programaSelected = this.state.listarPrograma.find(p => p.value === event.target.value);

    this.setState({
      programaSeleccionado: event.target.value,
      asignaturaSeleccionada: '',
      estudianteSeleccionado: '',
      cargando: true
    });

    if (programaSelected) {
      try {
        const datosProfesor = await this.ObtenerDatosProfesor(programaSelected.codigo, this.state.profesor.identificacion);
        const materiasProfesor = datosProfesor.materias.map((e) => ({
          value: `${e.cod_materia}_${e.id_grupo}`,
          label: `${e.nombre_grupo} - ${e.nombre_materia}`,
          codigo: e.cod_materia,
          cod_pensum: e.cod_pensum,
          cod_unidad: e.cod_unidad,
          id_grupo: e.id_grupo,
          nombre_materia: e.nombre_materia,
          nombre_grupo: e.nombre_grupo,
        }));

        this.setState({
          materiasProfesor,
          cargando: false
        });
      } catch (error) {
        this.setState({ cargando: false });
        this.props.actualizarMensaje({ titulo: 'Error al cargar las asignaturas', tipo: 'error', mostrar: true, tiempo: 4000 });
      }
    } else {
      this.setState({ cargando: false });
    }
  };

  handleAsignaturaChange = async (event) => {
    const asignaturaValue = event.target.value;
    const asignaturaSelected = this.state.materiasProfesor.find(a => a.value === asignaturaValue);

    this.setState({
      asignaturaSeleccionada: asignaturaValue,
      estudianteSeleccionado: '',
      cargando: true,
      asignaturaSeleccionadaObj: asignaturaSelected
    });

    if (asignaturaSelected && asignaturaSelected.id_grupo) {
      try {
        const idGrupo = asignaturaSelected.id_grupo;
        const datosEstudiantes = await this.ObtenerEstudiantesProfesor(idGrupo);

        if (datosEstudiantes && datosEstudiantes.estudiantes) {
          const estudiantesMateria = datosEstudiantes.estudiantes.map((e) => ({
            value: e.num_identificacion_estudiante,
            label: `${e.nom_largo}`,
            codigo: e.num_identificacion_estudiante
          }));

          this.setState({
            estudiantesMateria,
            cargando: false
          });
        } else {
          this.setState({
            estudiantesMateria: [],
            cargando: false
          });
          this.props.actualizarMensaje({ titulo: `No se recibieron datos de estudiantes válidos para grupo ${idGrupo}`, tipo: 'warning', mostrar: true, tiempo: 4000 });
        }
      } catch (error) {
        this.setState({
          estudiantesMateria: [],
          cargando: false
        });
        this.props.actualizarMensaje({ titulo: 'Error al cargar los estudiantes', tipo: 'error', mostrar: true, tiempo: 4000 });
      }
    } else {
      this.setState({
        estudiantesMateria: [],
        cargando: false
      });
      this.props.actualizarMensaje({ titulo: 'No se encontró el grupo para la asignatura seleccionada', tipo: 'warning', mostrar: true, tiempo: 4000 });
    }
  };

  handleEstudianteChange = (event) => {
    const estudianteId = event.target.value;
    const { estudiantesReportados } = this.state;

    const yaReportado = estudiantesReportados.some(reporte =>
      reporte.estudiante.value === estudianteId
    );

    if (yaReportado) {
      this.props.actualizarMensaje({ titulo: 'Este estudiante ya ha sido reportado', tipo: 'warning', mostrar: true, tiempo: 4000 });
      this.setState({ estudianteSeleccionado: '' });
      return;
    }

    this.setState({
      estudianteSeleccionado: estudianteId,
      modalObservacion: true,
      observacionReporte: ''
    });
  };

  continuarConReporte = () => {
    const { observacionReporte, estudianteSeleccionado, estudiantesReportados } = this.state;
    
    if (!observacionReporte.trim()) {
      this.props.actualizarMensaje({ titulo: 'Por favor ingrese una observación', tipo: 'warning', mostrar: true, tiempo: 4000 });
      return;
    }

    const estudiante = this.state.estudiantesMateria.find(e => e.value === estudianteSeleccionado);
    const asignatura = this.state.asignaturaSeleccionadaObj;
    const programa = this.state.listarPrograma.find(p => p.value === this.state.programaSeleccionado);

    const nuevoReporte = {
      estudiante,
      asignatura,
      programa,
      observacion: observacionReporte
    };

    this.setState({
      estudiantesReportados: [...estudiantesReportados, nuevoReporte],
      modalObservacion: false,
      estudianteSeleccionado: ''
    });
  };

  verDetalle = (estudiante) => {
    this.setState({
      modalDetalle: true,
      estudianteDetalle: estudiante
    });
  };

  eliminarReporte = (index) => {
    const nuevosReportes = this.state.estudiantesReportados.filter((_, i) => i !== index);
    this.setState({ estudiantesReportados: nuevosReportes });
  };

  enviarReportes = () => {
    const { estudiantesReportados, profesor } = this.state;
    
    if (estudiantesReportados.length === 0) {
      this.props.actualizarMensaje({ titulo: 'Debe reportar al menos un estudiante', tipo: 'warning', mostrar: true, tiempo: 4000 });
      return;
    }

    if (!profesor.id) {
      this.props.actualizarMensaje({ titulo: 'Debe seleccionar un profesor', tipo: 'warning', mostrar: true, tiempo: 4000 });
      return;
    }

    this.setState({ dialogoConfirmacion: true });
  };

  confirmarEnvio = async () => {
    this.setState({ cargando: true });

    const { estudiantesReportados, profesor, tipoAcompanamientoId } = this.state;
    const data = new FormData();

    data.append('total', estudiantesReportados.length.toString());
    data.append('profesor_id', profesor.id);
    data.append('tipo_acompanamiento_id', tipoAcompanamientoId);
    data.append('crear_acompanamiento', 'admin');

    estudiantesReportados.forEach((reporte, index) => {
      data.append(`reporte${index}_estudiante`, reporte.estudiante.value);
      data.append(`reporte${index}_asignatura`, reporte.asignatura.nombre_materia);
      data.append(`reporte${index}_grupo`, reporte.asignatura.nombre_grupo);
      data.append(`reporte${index}_programa`, reporte.programa.codigo);
      data.append(`reporte${index}_observacion_inicial`, reporte.observacion || '');
    });

    this.props.actualizarMensaje({ titulo: 'Enviando datos, por favor espere...', tipo: 'info', mostrar: true, tiempo: 4000 });
    
    // Aquí deberías usar el endpoint correcto para administradores
    formulario(`api/v1.0/acompanamiento_docente/crear`, data, "post", (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo;
          this.setState({
            programaSeleccionado: '',
            asignaturaSeleccionada: '',
            estudiantesReportados: [],
            profesor: { id: '', identificacion: '', nombre_completo: '' },
            dialogoConfirmacion: false,
            cargando: false,
            listarPrograma: [],
            materiasProfesor: [],
            estudiantesMateria: []
          });
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
          this.setState({ cargando: false, dialogoConfirmacion: false });
        }
      } else {
        this.setState({ cargando: false, dialogoConfirmacion: false });
      }
      this.props.actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    });
  };

  render() {
    const { classes } = this.props;
    const {
      programaSeleccionado,
      asignaturaSeleccionada,
      estudianteSeleccionado,
      profesor,
      buscarProfesor,
      estudiantesReportados,
      modalDetalle,
      estudianteDetalle,
      dialogoConfirmacion,
      cargando
    } = this.state;

    const asignaturasDisponibles = programaSeleccionado ? this.state.materiasProfesor || [] : [];
    const estudiantesDisponibles = asignaturaSeleccionada ? this.state.estudiantesMateria || [] : [];

    return (
      <div className={classes.container}>
        {cargando ? (
          <TareasTerminadas mensaje={'Cargando...'} marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />
        ) : (
          <>
            <Card className={classes.intro}>
              <Typography variant="body1">
                Primero seleccione el profesor, luego el programa académico, asignatura y los estudiantes que desea reportar.
              </Typography>
            </Card>

            <Card className={classes.card}>
              <CardContent>
                <Typography variant="h5" className={classes.sectionTitle}>
                  Nuevo Acompañamiento Docente
                </Typography>

                {/* Campo de Profesor - Ahora es el primero */}
                <Grid container spacing={1} alignItems="flex-end" onClick={() => this.setState({ buscarProfesor: true })} className={classes.pointer} style={{ marginBottom: '20px' }}>
                  <Grid item xs={11} xl={11} sm={11} md={11} lg={11}>
                    <TextField label="Profesor *" disabled={true} type="text" value={profesor.nombre_completo} style={{ width: '100%' }} />
                  </Grid>
                  <Grid item xs={1} xl={1} sm={1} md={1} lg={1}>
                    <SearchIcon style={{ color: '#B70E0C' }} />
                  </Grid>
                </Grid>

                <FormControl className={classes.formControl} disabled={!profesor.id || cargando}>
                  <InputLabel>Programa Académico *</InputLabel>
                  <Select
                    value={programaSeleccionado}
                    onChange={this.handleProgramaChange}
                  >
                    {(this.state.listarPrograma || []).map((programa) => (
                      programa && programa.label ? (
                        <MenuItem key={programa.value} value={programa.value}>
                          {programa.label}
                        </MenuItem>
                      ) : null
                    ))}
                  </Select>
                </FormControl>

                <FormControl className={classes.formControl} disabled={!programaSeleccionado || cargando}>
                  <InputLabel>Asignatura *</InputLabel>
                  <Select
                    value={asignaturaSeleccionada}
                    onChange={this.handleAsignaturaChange}
                  >
                    {(asignaturasDisponibles || []).map((asignatura) => (
                      asignatura && asignatura.label ? (
                        <MenuItem key={asignatura.value} value={asignatura.value}>
                          {asignatura.label}
                        </MenuItem>
                      ) : null
                    ))}
                  </Select>
                </FormControl>

                <FormControl className={classes.formControl} disabled={!asignaturaSeleccionada || cargando}>
                  <InputLabel>Estudiante a reportar *</InputLabel>
                  <Select
                    value={estudianteSeleccionado}
                    onChange={this.handleEstudianteChange}
                  >
                    {(estudiantesDisponibles || []).map((estudiante) => (
                      estudiante && estudiante.label ? (
                        <MenuItem key={estudiante.value} value={estudiante.value}>
                          {estudiante.value} - {estudiante.label}
                        </MenuItem>
                      ) : null
                    ))}
                  </Select>
                </FormControl>
              </CardContent>
            </Card>

            {estudiantesReportados.length > 0 && (
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Estudiantes Reportados ({estudiantesReportados.length})
                  </Typography>
                  <List>
                    {estudiantesReportados.map((reporte, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={reporte.estudiante.label}
                          secondary={
                            <>
                              <div>{`${reporte.asignatura.codigo} - ${reporte.asignatura.label}`}</div>
                              <div style={{ fontSize: '0.8rem', color: '#666', marginTop: 4 }}>
                                <strong>Observación:</strong> {reporte.observacion || 'Sin observación'}
                              </div>
                            </>
                          }
                        />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => this.verDetalle(reporte)}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton onClick={() => this.eliminarReporte(index)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Box textAlign="center" marginTop={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.enviarReportes}
                      size="large"
                    >
                      Enviar Todos los Reportes
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            )}
          </>
        )}

        {/* Modal de Observación */}
        <Dialog
          open={this.state.modalObservacion}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ backgroundColor: '#B70E0C', color: 'white' }}>
            Observación del Reporte
          </DialogTitle>
          <DialogContent style={{ padding: '20px' }}>
            <Typography variant="body2" style={{ marginBottom: 16 }}>
              Por favor, indique la razón por la cual está reportando a este estudiante:
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={this.state.observacionReporte}
              onChange={(e) => this.setState({ observacionReporte: e.target.value })}
              placeholder="Escriba aquí la observación del reporte..."
              variant="outlined"
              required
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ modalObservacion: false, estudianteSeleccionado: '' })}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              onClick={this.continuarConReporte}
              color="primary"
              variant="contained"
              size="small"
            >
              Agregar Reporte
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Búsqueda de Profesor */}
        <Dialog fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600} open={buscarProfesor} onClose={() => this.setState({ buscarProfesor: false })}>
          <AppBarModal titulo={'¡ Buscar Profesor !'} mostrarModal={() => this.setState({ buscarProfesor: false })} titulo_accion="CERRAR" accion={() => this.setState({ buscarProfesor: false })} />
          <DialogContent style={{ padding: '0' }} className='scroll'>
            <BuscarPersona callback={({ id, identificacion, primer_nombre, primer_apellido, segundo_apellido }) => {
              const profesorData = {
                id,
                identificacion,
                nombre_completo: `${primer_nombre} ${primer_apellido} ${segundo_apellido}`,
              };
              this.setState({
                profesor: profesorData,
                buscarProfesor: false,
                programaSeleccionado: '',
                asignaturaSeleccionada: '',
                estudianteSeleccionado: '',
                listarPrograma: [],
                materiasProfesor: [],
                estudiantesMateria: []
              });
              // Cargar programas del profesor seleccionado
              this.cargarProgramasProfesor(identificacion);
            }} />
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => this.setState({ buscarProfesor: false })} />
          </DialogActions>
        </Dialog>

        {/* Modal de Detalle */}
        <Dialog
          open={modalDetalle}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ backgroundColor: '#B70E0C', color: 'white' }}>
            Detalle del Reporte
          </DialogTitle>
          <DialogContent style={{ padding: '20px' }}>
            {estudianteDetalle && (
              <div>
                <Box mb={2} p={2} bgcolor="#f8f9fa" borderRadius={1}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#B70E0C' }}>
                    {estudianteDetalle.estudiante.label}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {estudianteDetalle.asignatura.nombre_materia}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Programa: {estudianteDetalle.programa.label}
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: 8, fontWeight: 500 }}>
                    <strong>Observación del reporte:</strong>
                  </Typography>
                  <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                    {estudianteDetalle.observacion || 'Sin observación'}
                  </Typography>
                </Box>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ modalDetalle: false })}
              size="small"
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Confirmación de Envío */}
        <Dialog
          open={dialogoConfirmacion}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle style={{ backgroundColor: '#B70E0C', color: 'white' }}>
            Confirmar Envío
          </DialogTitle>
          <DialogContent style={{ padding: '20px' }}>
            <Typography variant="body2">
              ¿Está seguro de que desea enviar todos los reportes?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ dialogoConfirmacion: false })}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              onClick={this.confirmarEnvio}
              color="primary"
              variant="contained"
              size="small"
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return {
    usuario
  };
};

const mapDispatchToProps = {
  actualizarMensaje
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NuevoAdministrar));